module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#trending",
      toString: function () {
        return this.url;
      }
    }